class WelcomePopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'vmWelcomePopupDismissedAt';
    this.dismissWindowMs = 30 * 24 * 60 * 60 * 1000;
    this.lastFocusedElement = null;
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-vm-popup-overlay]');
    this.dialog = this.querySelector('.vm-welcome-popup__dialog');

    this.querySelectorAll('[data-vm-popup-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) this.close();
    });

    const copyButton = this.querySelector('[data-vm-popup-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', () => this.copyCode(copyButton));
    }

    if (this.dataset.openOnLoad === 'true') {
      this.open();
      this.remember();
      return;
    }

    if (this.shouldShow()) {
      const delay = Number(this.dataset.delay) || 1500;
      this.openTimer = window.setTimeout(() => this.open(), delay);
    }
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
    document.removeEventListener('keydown', this.onKeydown);
  }

  shouldShow() {
    let dismissedAt = 0;
    try {
      dismissedAt = Number(window.localStorage.getItem(this.storageKey)) || 0;
    } catch (error) {
      return true;
    }
    return Date.now() - dismissedAt > this.dismissWindowMs;
  }

  open() {
    this.lastFocusedElement = document.activeElement;
    this.hidden = false;
    document.addEventListener('keydown', this.onKeydown);

    const focusTarget = this.querySelector('[data-vm-popup-autofocus]') || this.dialog;
    window.requestAnimationFrame(() => focusTarget.focus());
  }

  close() {
    if (this.hidden) return;
    this.hidden = true;
    this.remember();
    document.removeEventListener('keydown', this.onKeydown);

    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
      this.lastFocusedElement.focus();
    }
  }

  remember() {
    try {
      window.localStorage.setItem(this.storageKey, String(Date.now()));
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - nothing to persist
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key === 'Tab') {
      this.trapFocus(event);
    }
  }

  trapFocus(event) {
    const focusable = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  copyCode(button) {
    const code = button.dataset.code;
    const label = button.querySelector('[data-vm-popup-copy-label]');
    if (!code || !navigator.clipboard) return;

    navigator.clipboard
      .writeText(code)
      .then(() => {
        if (!label) return;
        const original = label.textContent;
        label.textContent = 'Copied';
        window.setTimeout(() => {
          label.textContent = original;
        }, 2000);
      })
      .catch(() => {});
  }
}

customElements.define('welcome-popup', WelcomePopup);
